import { roundToDecimalFactor } from "common/utils/numbers";
import { DIST_EPSILON } from "geom/core";

const RELATIVE_INSET_DECIMAL_PLACES = 6;
const RELATIVE_INSET_DECIMAL_FACTOR = 1 / DIST_EPSILON;

/** Quantize a relative plane-UV inset to DIST_EPSILON precision. */
export function quantizePlanarTopologyRelativeInset(value: number): number {
  return roundToDecimalFactor(value, RELATIVE_INSET_DECIMAL_FACTOR);
}

/** Serialize a relative inset for stable topology handle hashing. */
export function serializePlanarTopologyRelativeInset(value: number): string {
  return quantizePlanarTopologyRelativeInset(value).toFixed(RELATIVE_INSET_DECIMAL_PLACES);
}

/** Parse a relative inset from a topology handle hash segment. */
export function parsePlanarTopologyRelativeInset(value: string): number {
  return quantizePlanarTopologyRelativeInset(Number.parseFloat(value));
}
